import { render, staticRenderFns } from "./DeSelectGrid.vue?vue&type=template&id=fa654254&scoped=true&"
import script from "./DeSelectGrid.vue?vue&type=script&lang=js&"
export * from "./DeSelectGrid.vue?vue&type=script&lang=js&"
import style0 from "./DeSelectGrid.vue?vue&type=style&index=0&id=fa654254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa654254",
  null
  
)

export default component.exports